export const sapOrganizationKeys = {
  all: ["sapOrganization"] as const,
  find: (orgId: string) => [...sapOrganizationKeys.all, orgId] as const,
  bound: (orgId: string) => [...sapOrganizationKeys.all, "bound", orgId] as const,
};
